import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Loader from 'components/common/Loader';
import { SearchBox } from 'components/content/SearchBox';
import { SearchItemList } from 'components/content/SearchItemList';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { searchProducts } from 'services/networking/affiliation';
import { AffiliationLink } from 'theme/icons';
import { Description, SearchProductWrapper } from './SearchProduct.style';

var SearchProduct = function SearchProduct(_ref) {
  var _ref$initialSearchTex = _ref.initialSearchText,
      initialSearchText = _ref$initialSearchTex === void 0 ? '' : _ref$initialSearchTex,
      onProductClick = _ref.onProductClick;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var intl = useIntl();

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState({
    search: initialSearchText,
    result: [],
    loading: initialSearchText !== ''
  }),
      _useState$ = _useState[0],
      searchText = _useState$.search,
      searchResult = _useState$.result,
      searchLoading = _useState$.loading,
      setSearchState = _useState[1];

  var handleSearchProducts = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(search) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(search !== '')) {
                _context2.next = 5;
                break;
              }

              setSearchState({
                search: search,
                loading: true,
                result: []
              });
              _context2.next = 4;
              return snackAsyncError({
                messageId: 'affiliation.error.search-product',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$searchProducts, foundProducts;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return searchProducts(search, site);

                          case 2:
                            _yield$searchProducts = _context.sent;
                            foundProducts = _yield$searchProducts.products;
                            setSearchState({
                              search: search,
                              loading: false,
                              result: foundProducts
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }(),
                errorCallback: function errorCallback() {
                  setSearchState({
                    search: search,
                    loading: false,
                    result: []
                  });
                }
              });

            case 4:
              return _context2.abrupt("return");

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [site, snackAsyncError]);

  var handleProductClick = function handleProductClick(product) {
    onProductClick(product, searchText);
  };

  return __jsx(SearchProductWrapper, null, __jsx(FormattedMessage, {
    id: "search-product.description",
    tagName: Description
  }), __jsx(SearchBox, {
    fieldLabelId: "filters.search",
    refine: handleSearchProducts,
    currentRefinement: searchText
  }), searchText.length > 0 ? __jsx(SearchItemList, {
    searchText: searchText,
    searchItems: searchResult.map(function (product) {
      return _objectSpread(_objectSpread({}, product), {}, {
        id: "".concat(product.apiId, "#").concat(product.productId),
        price: product.price === null || product.price === undefined ? intl.formatMessage({
          id: 'search-product.price-not-available'
        }) : "".concat(product.price, "\u20AC")
      });
    }),
    fieldsMapping: {
      id: 'id',
      label: 'name',
      subLabel: 'price',
      previewImage: ''
    },
    loading: searchLoading,
    HoverIcon: AffiliationLink,
    onClick: handleProductClick
  }) : searchLoading && __jsx(Loader, null));
};

export default SearchProduct;